import { render, staticRenderFns } from "./MyRoomsPage.vue?vue&type=template&id=01152e07&scoped=true"
import script from "./MyRoomsPage.vue?vue&type=script&lang=js"
export * from "./MyRoomsPage.vue?vue&type=script&lang=js"
import style0 from "./MyRoomsPage.vue?vue&type=style&index=0&id=01152e07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01152e07",
  null
  
)

export default component.exports